
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FlexibleSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"flexibleSections_NeoField"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleAccordion"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleCallToAction"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleImage"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleImages"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleQuickLinks"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleQuote"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleRichtext"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleFeaturedPages"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleNewsAndUpdates"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleStatistics"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleStories"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleTextImage"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleTextText"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleTextVideo"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleVideo"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexibleEmergencySupportForm"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FlexiblePdfEmbed"},"directives":[]}]}}],"loc":{"start":0,"end":1768}};
    doc.loc.source = {"body":"#import \"~/graphql/fragments/FlexibleSections/FlexibleAccordion.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleCallToAction.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleImage.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleImages.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleQuickLinks.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleQuote.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleRichtext.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleFeaturedPages.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleNewsAndUpdates.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleStatistics.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleStories.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleTextImage.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleTextText.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleTextVideo.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleVideo.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexibleEmergencySupportForm.graphql\"\n#import \"~/graphql/fragments/FlexibleSections/FlexiblePdfEmbed.graphql\"\n\nfragment FlexibleSections on flexibleSections_NeoField {\n    __typename\n    ... FlexibleAccordion\n    ... FlexibleCallToAction\n    ... FlexibleImage\n    ... FlexibleImages\n    ... FlexibleQuickLinks\n    ... FlexibleQuote\n    ... FlexibleRichtext\n    ... FlexibleFeaturedPages\n    ... FlexibleNewsAndUpdates\n    ... FlexibleStatistics\n    ... FlexibleStories\n    ... FlexibleTextImage\n    ... FlexibleTextText\n    ... FlexibleTextVideo\n    ... FlexibleVideo\n    ... FlexibleEmergencySupportForm\n    ... FlexiblePdfEmbed\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleAccordion.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleCallToAction.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleImage.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleImages.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleQuickLinks.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleQuote.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleRichtext.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleFeaturedPages.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleNewsAndUpdates.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleStatistics.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleStories.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleTextImage.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleTextText.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleTextVideo.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleVideo.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexibleEmergencySupportForm.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/FlexibleSections/FlexiblePdfEmbed.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FlexibleSections"] = oneQuery(doc, "FlexibleSections");
        
